export default "__VITE_ASSET__a9d7Siy1__"